import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from 'vue';
import { config } from '@/store';

const __default__ = { name: 'table-pager' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ['page', 'count', 'pageSizeConfig'],
  emits: ['pageChange'],
  setup(__props, { expose: __expose, emit: __emit }) {

const pageSize = ref(10);
const disabled = ref(false);
const background = ref(true);
const pageSizes = ref([10, 20, 30, 40]);

// 传值
const props = __props;
const emit = __emit;
__expose({ page_change, reload_page });

let pagerPage = computed(() => {
  return props.page;
})

const pageCount = computed(() => {
  // 展示最大页码数量
  const screenType = config.screenType;
  switch (screenType) {
    case '2k':
      return 46;
    case 'large':
      return 17;
    case 'middle':
      return 11;
    case 'small':
      return 7;
    case 'mini':
      return 5;
    default:
      return 21;
  }
})

let pageSmall = computed(() => {
  const screenType = config.screenType;
  switch (screenType) {
    case 'large':
      return false;
    case 'middle':
      return false;
    case 'small':
      return true;
    case 'mini':
      return true;
    default:
      return false;
  }
})

let pageLayout = computed(() => {
  const screenType = config.screenType;
  switch (screenType) {
    case 'large':
      return 'total, sizes, prev, pager, next, jumper';
    case 'middle':
      return 'sizes, prev, pager, next, jumper';
    case 'small':
      return 'prev, pager, next, jumper';
    case 'mini':
      return 'prev, pager, next, jumper';
    default:
      return 'total, sizes, prev, pager, next, jumper';
  }
})

/**
 * 页码尺寸变更
 * @param size
 */
function size_change(size: number) {
  pageSize.value = size;
  page_change();
}
/**
 * 页码变更
 * @param page
 */
function page_change(page = 1) {
  emit('pageChange', page, pageSize.value);
}
/**
 * 重载数据 不改变页码
 */
function reload_page() {
  emit('pageChange', props.page, pageSize.value);
}

const __returned__ = { pageSize, disabled, background, pageSizes, props, emit, get pagerPage() { return pagerPage }, set pagerPage(v) { pagerPage = v }, pageCount, get pageSmall() { return pageSmall }, set pageSmall(v) { pageSmall = v }, get pageLayout() { return pageLayout }, set pageLayout(v) { pageLayout = v }, size_change, page_change, reload_page }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})